import { Ref } from 'vue'

/**
 * Helper function to handle ref type loading state.
 * @param {Ref<boolean>} loadingState - The async loading state parameter.
 * @param {Ref<boolean>} errorState - Parameter keeping track of error state.
 */
export async function handleLoadingState(
  loadingState: Ref<boolean>,
  errorState: Ref<boolean>,
  asyncFunc: () => Promise<void>
) {
  try {
    loadingState.value = true
    await asyncFunc()
    errorState.value = false
  } catch (error) {
    console.error('There was an unexpected error calling the API')
    console.error(error)
    errorState.value = true
  } finally {
    loadingState.value = false
  }
}
